import React, { useCallback, useEffect, useState } from 'react'
import { LibraryHeader } from '../../../components/Library/LibraryHeader'
import { LibraryOscCard } from '../../../components/Library/LibraryOscCard'
import { SpinnerLoad } from '../../../components/Loading/SpinnerLoad'
import useApi from '../../../hooks/useApi'
import { OscLoggedLayout } from '../../../layout/OscLoggedLayout'
import { Material as Type } from '../../../types/Material'



export const Material = () => {
    
    const api = useApi() 
    const [hints,setHints] = useState<Type[]>([])
    const [load,setLoad] = useState<boolean>(false)


    const loadMaterials = useCallback(async ()=>{
        setLoad(true)
        await api.get("/client/library/materials").then(res => {
                setHints(res.data)
        }).catch(console.log)
        setLoad(false)
    },[api,setHints])

    useEffect(()=>{
        loadMaterials()
    },[loadMaterials])

    return(
        <OscLoggedLayout>
             <LibraryHeader osc page='Dica'/>
             {!load &&
             <div className='grid grid-cols-3 gap-x-16 gap-y-2'>
             {hints.map(item => (
                 <LibraryOscCard type='materials' download item={item} />
             ))}
             </div>}
             {load && <div className='mt-4'> <SpinnerLoad/> </div>}
        </OscLoggedLayout>
    )
}
